import React, { Component } from 'react'
import PropTypes from 'prop-types'

function sortByLabel ([ _, labelA ], [ __, labelB ]) {
  if (labelA > labelB) {
    return 1
  }

  if (labelA < labelB) {
    return -1
  }

  return 0
}

export default class AllFilters extends Component {
  static propTypes = {
    applyFilter: PropTypes.func,
    amenities: PropTypes.arrayOf(PropTypes.string).isRequired,
    amenityCounts: PropTypes.objectOf(PropTypes.number).isRequired,
    amenityDefinition: PropTypes.objectOf(PropTypes.string).isRequired,
    onChange: PropTypes.func,
  }

  state = {
    amenities: [],
  }

  constructor (props) {
    super(props)

    this.state = {
      amenities: props.amenities,
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      amenities: nextProps.amenities,
    })
  }

  applyFilter = () => {
    this.props.applyFilter({
      amenities: this.state.amenities,
    })
  }

  handleChange = (value) => {
    if (this.props.onChange) {
      this.props.onChange(value)
    } else {
      this.setState((state) => ({
        amenities: state.amenities.includes(value)
          ? state.amenities.filter((item) => item !== value)
          : [ ...state.amenities, value ],
      }))
    }
  }

  toggleAmenityFactory = (value) => () => this.handleChange(value)

  render () {
    const { amenityCounts, amenityDefinition, applyFilter } = this.props
    const { amenities } = this.state

    return (
      <>
        <div className='form__group'>
          <label className='form__label'>Amenities</label>
          <div className='form__control'>
            <ul className='option-list option-list--amenities'>
              {Object.entries(amenityDefinition).sort(sortByLabel).map(([value, label]) => (
                <li key={value}>
                  <input
                    className='checkbox-item form__checkbox'
                    checked={amenities.includes(value)}
                    type='checkbox'
                    id={value}
                    onChange={this.toggleAmenityFactory(value)}
                  />
                  <label htmlFor={value}>
                    {label}
                    <span className='badge badge--search-filter'>{amenityCounts[value]}</span>
                  </label>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {applyFilter && <button type='button' className='btn btn--primary filter-button' onClick={this.applyFilter}>Apply filters</button>}
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/filters/Amenities.js